import React from 'react';
import { PageHead } from './ui';

// Placeholder for admin sections that depend on ticket orders / Stripe, which aren't built yet.
export default function ComingSoon({ title, message }) {
  return (
    <div>
      <PageHead title={title} subtitle="Not available yet" />
      <div className="adm-card adm-soon-card">
        <div className="adm-soon-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24"><path d="M12 6v6l4 2M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" /></svg>
        </div>
        <h3>Coming soon</h3>
        <p>{message}</p>
      </div>
    </div>
  );
}
